import React, { useState } from 'react';
import './UserReviews.css';

const reviews = [
  {
    id: 1,
    name: 'Sarah J.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face',
    date: 'January 2026',
    rating: 5,
    text: 'Great place for a quick stop with the little ones. Very accommodating staff! The nursing room was spotless and private. Will definitely be back.',
    helpful: 24,
  },
  {
    id: 2,
    name: 'Mike T.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face',
    date: 'January 2026',
    rating: 5,
    text: 'Loved the play area, and the staff was very friendly! My toddler had a blast while I enjoyed a peaceful coffee. Changing facilities are top-notch.',
    helpful: 18,
  },
  {
    id: 3,
    name: 'Emma L.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face',
    date: 'December 2025',
    rating: 4,
    text: 'Really appreciate having a place like this nearby. The high chairs are clean and sturdy. Only minor issue was limited parking on weekends.',
    helpful: 12,
  },
  {
    id: 4,
    name: 'David K.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face',
    date: 'December 2025',
    rating: 5,
    text: 'Finally a cafe that truly understands families with babies! The bottle warming service saved us. Staff even helped entertain our fussy baby.',
    helpful: 31,
  },
];

const ratingBreakdown = [
  { stars: 5, count: 98, percentage: 77 },
  { stars: 4, count: 21, percentage: 17 },
  { stars: 3, count: 6, percentage: 5 },
  { stars: 2, count: 2, percentage: 1 },
  { stars: 1, count: 0, percentage: 0 },
];

const UserReviews = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedReviews = showAll ? reviews : reviews.slice(0, 2);

  return (
    <div className="reviews-section">
      <div className="reviews-header">
        <h2 className="reviews-title">
          <span className="star">★</span> 4.8 · 127 reviews
        </h2>
      </div>

      <div className="reviews-summary">
        <div className="rating-breakdown">
          {ratingBreakdown.map((r) => (
            <div key={r.stars} className="rating-row">
              <span className="rating-label">{r.stars}</span>
              <div className="rating-bar">
                <div className="rating-bar__fill" style={{ width: `${r.percentage}%` }} />
              </div>
            </div>
          ))}
        </div>
        <div className="rating-categories">
          <div className="rating-category">
            <span className="rating-category__label">Cleanliness</span>
            <div className="rating-category__score">
              <div className="score-bar"><div className="score-bar__fill" style={{ width: '96%' }} /></div>
              <span>4.8</span>
            </div>
          </div>
          <div className="rating-category">
            <span className="rating-category__label">Baby-friendliness</span>
            <div className="rating-category__score">
              <div className="score-bar"><div className="score-bar__fill" style={{ width: '98%' }} /></div>
              <span>4.9</span>
            </div>
          </div>
          <div className="rating-category">
            <span className="rating-category__label">Staff helpfulness</span>
            <div className="rating-category__score">
              <div className="score-bar"><div className="score-bar__fill" style={{ width: '94%' }} /></div>
              <span>4.7</span>
            </div>
          </div>
          <div className="rating-category">
            <span className="rating-category__label">Value</span>
            <div className="rating-category__score">
              <div className="score-bar"><div className="score-bar__fill" style={{ width: '90%' }} /></div>
              <span>4.5</span>
            </div>
          </div>
        </div>
      </div>

      <div className="reviews-list">
        {displayedReviews.map((review) => (
          <div key={review.id} className="review-card">
            <div className="review-header">
              <img src={review.avatar} alt={review.name} className="review-avatar" />
              <div className="review-meta">
                <span className="review-name">{review.name}</span>
                <span className="review-date">{review.date}</span>
              </div>
            </div>
            <div className="review-rating">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={`review-star ${i < review.rating ? 'review-star--filled' : ''}`}>★</span>
              ))}
            </div>
            <p className="review-text">{review.text}</p>
            <button className="review-helpful">
              👍 Helpful ({review.helpful})
            </button>
          </div>
        ))}
      </div>

      {!showAll && (
        <button className="show-all-reviews-btn" onClick={() => setShowAll(true)}>
          Show all 127 reviews
        </button>
      )}
    </div>
  );
};

export default UserReviews;
